import React, { Component } from 'react';

import { translate } from "react-translate";

import MenuComponent from '../MenuComponent';
import FooterComponent from '../FooterComponent';

import {
    Segment,
    Image,
    Header,
    Container,
    Divider
} from 'semantic-ui-react';

import imageCgu from '../../../assets/img/cguv.png';

class MentionsLegalesComponent extends Component {

    render() {

        const { t } = this.props;

        return (
            <div>
                <MenuComponent />
                
                <Segment vertical id="sectionCguv">
                    <Image
                        src={imageCgu}
                        id="sectionCguvImage"
                        fluid />
                    <div id="containerCguv">
                        <Container textAlign='center'>
                            <Header size='huge' as='h1' id="containerCguvTitre">{t("Segment1_title")}</Header>
                        </Container>

                        <Container textAlign='center'>
                            <p id="containerCguvDescription">
                                {t("Segment1_description")}
                            </p>
                        </Container>
                    </div>
                </Segment>

                <Segment vertical id="sectionCguvContent">
                    <Container>
                        <Header as='h3' size="huge" id="sectionCguvContentTitre">{t("Segment2_title")}</Header>
                    </Container>
                    <Container textAlign='center' >
                        <p id="sectionCguvContentLaw">
                        Mentions Légales

                        Dénomination commerciale : MYTRAVO
                        Forme juridique : Micro Entreprise
                        Capital : N/A
                        N° d’inscription au R.C.S. Paris : N/A
                        N° SIREN : 513548693
                        N° SIRET : 513 548 693 00029
                        Code APE : 4791B

                        Adresse du siège social : 58 avenue du Général Eisenhower 51100 REIMS, FRANCE
                        Adresse email : contact@mytravo.net
                        N° TVA intracommunautaire : N/A

                        Le Site Internet est hébergé par la société Amazon Web service dont le siège social est au P.O. Box 81226, Seattle, WA 98108-1226 http://aws.amazon.com.

                        Le site Internet et les données applicatives sont hébergées par la société OVH dont le siège social est au 2 rue Kellermann - 59100 Roubaix - France. Adresse de courrier électronique : contact@ovh.com. La société OVH dispose de Data-Centers hautement sécurisés situés en France, offrant d’importantes garanties de sécurité et respecte la législation européenne concernant les données personnelles.

                        Le directeur de la publication est le fondateur de la société : Mr Guillaume BLANC.

                        L'accès au Site, sa consultation et son utilisation sont subordonnés à l'acceptation sans réserve des présentes <a href='/cguv'>Conditions Générales d’Utilisation et de Ventes du site</a>.

                        Le présent Site a fait l'objet d'une déclaration à la Commission Nationale de l'Informatique et des Libertés (CNIL) sous le numéro 20163032. L'utilisateur de ce site est informé que, conformément à la loi n°78-17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, les informations qu'il communique par le biais des formulaires présents sur le site sont nécessaires pour répondre à sa demande. Il dispose d’un droit, d'accès de modification ou de suppression concernant ses données personnelles en écrivant à : MYTRAVO, 58 avenue du Général Eisenhower 51100 REIMS, FRANCE.

                        Toute reproduction, représentation, traduction, adaptation, ou citation qu'elle soit intégrale ou partielle, quelqu'en soit le procédé, est strictement interdite sans autorisation expresse de la société. Les marques citées sont la propriété de leurs détenteurs respectifs.

                        Malgré le soin apporté au traitement du contenu, la société décline toute responsabilité concernant les erreurs ou omissions portant sur les informations diffusées sur ce site.

                        </p>
                    </Container>
                </Segment>

                <FooterComponent />
            </div>
        );
    }
}

export default translate("MentionsLegalesComponent")(MentionsLegalesComponent);



// WEBPACK FOOTER //
// ./src/components/Public/MentionsLegalesPage/MentionsLegalesComponent.js